import { createContext, useCallback, useMemo, useState } from 'react';
import { SearchTarjetaRequest } from '../models/SearchTarjetaRequest';
import { useSearchParams } from 'react-router-dom';

interface ICardListContext {
  searchParams: SearchTarjetaRequest | null;
  searchCards: (request: SearchTarjetaRequest) => void;
  reloadToken: number;
  reloadCardsAndFilters: () => void;
}

export const CardListContext = createContext<ICardListContext>({
  searchParams: {},
  searchCards: () => {},
  reloadToken: 0,
  reloadCardsAndFilters: () => {},
});

export const CardListProvider = ({ children }) => {
  const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
  const [reloadToken, setReloadToken] = useState(0);

  const searchParams: SearchTarjetaRequest = useMemo(() => {
    const centroCostoAsociadoId = searchParamsUrl.get('centroCostoAsociadoId');
    return {
      centroCostoOrigenId: centroCostoAsociadoId ? Number(centroCostoAsociadoId) : null,
      numeroCuenta: searchParamsUrl.get('numeroCuenta'),
      numeroTarjeta: searchParamsUrl.get('numeroTarjeta'),
      denominacionTarjeta: searchParamsUrl.get('denominacionTarjeta'),
      page: searchParamsUrl.get('page') == null ? 0 : Number(searchParamsUrl.get('page')),
      size: searchParamsUrl.get('size') == null ? 15 : Number(searchParamsUrl.get('size')),
    };
  }, [searchParamsUrl]);

  const searchCards = useCallback(
    (request: SearchTarjetaRequest) => {
      const rawData = {
        centroCostoAsociadoId: request.centroCostoOrigenId,
        numeroCuenta: request.numeroCuenta,
        numeroTarjeta: request.numeroTarjeta,
        denominacionTarjeta: request.denominacionTarjeta,
      };
      // Filtramos valores nulos
      const cleanEntries = Object.entries(rawData)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, String(value)]);
      setSearchParamsUrl(new URLSearchParams(cleanEntries));
    },
    [setSearchParamsUrl],
  );

  const reloadCardsAndFilters = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  return (
    <CardListContext.Provider
      value={{
        searchParams,
        searchCards,
        reloadToken,
        reloadCardsAndFilters,
      }}
    >
      {children}
    </CardListContext.Provider>
  );
};
